import React from 'react';
import { useSelector } from 'react-redux';
import CreateUpdateContent from '../components/pages/group/create-update-view/content';

function GroupFormPage(props) {
  const organisations = useSelector((state) => state.organisationsReducer.groups);
  const groupForm = useSelector((state) => state.groupsReducer.groupForm);

  return (
    <>
      <CreateUpdateContent organisations={organisations} groupForm={groupForm} updateOrInsert={props.updateOrInsert} />
    </>
  );
}

export default GroupFormPage;
